import { intlLocale } from "./intlLocale";

const formatters = new Map<string, Intl.NumberFormat>();

/**
 * Format a plain COUNT (or any bare number) for display in the active UI
 * language. Routes through `intlLocale`, so Arabic renders Arabic-Indic digits
 * (٠-٩) and English renders Latin — matching how money (`formatJod`) and dates
 * (`intlDateLocale`) already shape their digits.
 *
 * Use this at call sites that interpolate a raw JavaScript number straight into
 * JSX (count badges, filter chips, tab counters). A bare `{count}` in JSX always
 * renders Western digits regardless of locale; `formatCount(count, i18n.language)`
 * shapes it correctly. It also honours the per-user numerals preference, since
 * `intlLocale` does.
 *
 * NOT for identifiers or codes (employee/request codes, period codes, IBANs,
 * technical ids) — those stay Latin; render them as plain strings.
 */
export function formatCount(value: number, lang: string | null | undefined): string {
  // Keyed by the resolved tag, which carries `-u-nu-latn` in Latin mode, so a
  // numerals switch picks a different formatter. At most three entries.
  const tag = intlLocale(lang);
  let formatter = formatters.get(tag);
  if (formatter === undefined) {
    formatter = new Intl.NumberFormat(tag);
    formatters.set(tag, formatter);
  }
  return formatter.format(value);
}
